<template>
  <div>
    <validation-observer #default="{ handleSubmit }">
      <b-form @submit.prevent>
        <b-tabs
          v-model="tabIndex"
        >
          <!-- Basic Info Tab -->
          <b-tab>
            <template #title>
              <div class="mb-1">
                <span
                  class="rounded-circle d-inline-block text-center text-white mr-1 tab-number bg-green"
                >1</span>
                Basic Info
              </div>
            </template>

            <event-basic-inputs :event="event" />

            <!-- Buttons -->
            <b-row align-h="between">
              <b-col md="2">
                <b-button
                  variant="outline-primary"
                  class="btn-pill"
                  block
                  @click="discard"
                >
                  Discard
                </b-button>
              </b-col>
              <b-col
                md="2"
                class="text-right mt-1 mt-md-0"
              >
                <b-button
                  variant="primary"
                  block
                  class="btn-pill"
                  @click="handleSubmit(()=>{tabIndex++})"
                >
                  Continue
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
          <!-- Event Details Tab -->
          <b-tab lazy>
            <template #title>
              <div class="mb-1">
                <span
                  class="rounded-circle d-inline-block text-center text-white mr-1 tab-number bg-green"
                >2</span>
                Event Details
              </div>
            </template>

            <event-details-inputs :event="event" />

            <!-- Buttons -->
            <b-row align-h="between">
              <b-col
                md="2"
                class="mb-1 mb-md-0"
              >
                <b-button
                  variant="outline-primary"
                  block
                  class="btn-pill"
                  @click="discard"
                >
                  Discard
                </b-button>
              </b-col>
              <b-col
                md="2"
                class="text-right"
              >
                <submit-button v-bind="{ submit, handleSubmit,btnClass:'btn-block' }" />
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import handleAlerts from '@/compositions/common/handleAlerts'
import SubmitButton from '../FormInputs/SubmitButton.vue'
import EventBasicInputs from './EventBasicInputs.vue'
import EventDetailsInputs from './EventDetailsInputs.vue'

export default {
  name: 'EventForm',
  components: { EventBasicInputs, EventDetailsInputs, SubmitButton },
  props: {
    event: { type: Object, default: () => {} },
    submit: { type: Function, default: () => {} },
  },
  data() {
    return {
      tabIndex: 0,
    }
  },
  setup() {
    const { confirmOperation } = handleAlerts()
    return { confirmOperation }
  },
  methods: {
    discard() {
      this.confirmOperation('All changes will be discarded', 'Discard').then(() => {
        this.$router.back()
      })
    },
  },
}
</script>

<style>
.tab-number {
  line-height: 2.8em;
  height: 2.8em;
  width: 2.8em;
}
</style>
